const MAP_SELECTOR = '.locator-map__google-map'
const MAP_STYLE = [{"featureType": "administrative","elementType": "labels.text.fill","stylers": [{"color": "#453135"}]},{"featureType": "administrative.locality","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "administrative.neighborhood","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "administrative.land_parcel","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "landscape.man_made","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "landscape.natural","elementType": "all","stylers": [{"color": "#dee8e4"}]},{"featureType": "landscape.natural","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "landscape.natural.terrain","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "poi","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "poi.business","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "poi.government","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "poi.medical","elementType": "all","stylers": [{"visibility": "off"},{"hue": "#2d00ff"}]},{"featureType": "poi.park","elementType": "all","stylers": [{"hue": "#71ff00"}]},{"featureType": "poi.park","elementType": "geometry","stylers": [{"visibility": "on"}]},{"featureType": "poi.park","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "poi.place_of_worship","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "poi.school","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "poi.sports_complex","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "road","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "transit","elementType": "all","stylers": [{"visibility": "off"},{"color": "#453135"}]},{"featureType": "water","elementType": "geometry","stylers": [{"color": "#7b8db8"}]},{"featureType": "water","elementType": "labels","stylers": [{"color": "#f7f1e4"}]}]
let MAP_OPTIONS = undefined, self

export default {
  locator: undefined,
  is_single: false,
  locations: [],

  init() {
    MAP_OPTIONS = {
      selectors: {
        form: '.locator-form',
        list: '.locations-list',
        where: 'input[name="where"]',
        radius: 'select[name="radius"]',
        limit: 'select[name="limit"]',
      },
      basicOptions: {
        zoom: 6,
        maxZoom: 18,
        minZoom: 4,
        singleMapZoom: 10,
        lat: 47.651,
        lng: -70.1503,
        mapStyle: MAP_STYLE,
        autoFadeIn: true,
        autoFitBounds: false,
        enableGeolocation: false,
        enablePositionMarker: false,
        putSearchParametersInURL: false,
      },
      clusterOptions: {
        useClusters: false,
      },
      bubbleOptions: {
        shadowStyle: 0,
        padding: 0,
        borderRadius: 0,
        borderWidth: 0,
        backgroundColor: 'transparent',
        minWidth: $.mlmi.mobile.isMobile ? $(window).width() - 88 : 470,
        maxWidth: $.mlmi.mobile.isMobile ? $(window).width() - 88 : 470,
        minHeight: $.mlmi.mobile.isMobile ? 180 : 240,
        maxHeight: $.mlmi.mobile.isMobile ? 180 : 240,
        arrowSize: 0,
        disableAutoPan: true,
        animatedPan: true,
      },
      getMarkerIcon: function(location) {
        let iconHeight = 44, iconWidth = 110 * 2/3
        switch (location.marker_id) {
          case 35: iconWidth = 124; break;
          case 592: iconWidth = 108; break;
          case 593: iconWidth = 110; break;
          case 594: iconWidth = 148; break;
          case 595: iconWidth = 93; break;
          case 598: iconWidth = 328; break;
          case 599: iconWidth = 222; break;
        }
        return {
          url: '/img/markers/marker.php?name=' + encodeURIComponent(location.city) + '&width=' + iconWidth,
          width: iconWidth,
          height: iconHeight,
          anchorX: iconWidth / 2,
          anchorY: iconHeight * .667,
          scaledWidth: iconWidth,
          scaledHeight: iconHeight,
          zIndex: 1,
        }
      },
    }

    self = this

    /* Map fixed */
    $('.locator-map:not(.locator-single-map .locator-map)').each(function() {
      let bottomBlocker = $(this).closest('.row').next('.row')
      $(this).FixedContent({
        limitFromTop: 20,
        bottomBlocker: $(this).closest('.row').next('.row'),
        mobile: false,
      })
    })

    this.is_single = $('.locator-map').closest('.locator-single-map').length > 0
    this.attachEvents()
  },

  attachEvents() {
    if ($(MAP_SELECTOR).length) {
      /* Initialize map when ready */
      if ('MLMI_Locator_Function' in window) {
        $.fn.MLMI_Locator = window.MLMI_Locator_Function
      }
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(self.attachEvents, 50)
      } else {
        /* Bubbles */
        const bubbleMaker = function(location) {
          let card = $('.locations-list .card-locator-item[data-id="' + location.id + '"]'),
          bubble = $('.locator-bubble--template').clone()
          bubble.removeClass('locator-bubble--template')
          bubble.find('.locator-bubble__container').html(card.clone())
          bubble = bubble.get(0)
          return bubble
        }

        /* Initialize map */
        if ($(window).width() >= 1900) {
          MAP_OPTIONS.basicOptions.zoom = 7
        } else if ($.mlmi.mobile.isMobile) {
          MAP_OPTIONS.basicOptions.zoom = 5
        }
        if (this.is_single) {
          MAP_OPTIONS.bubbleOptions.useBubbles = false
        }
        self.locator = $(MAP_SELECTOR).MLMI_Locator(MAP_OPTIONS, bubbleMaker)

        /* Get locations for filtering */
        if ('locations' in window) {
          self.locations = window.locations
        }

        /* Markers */
        self.locator.markers.map(function(marker, i) {
          google.maps.event.addListener(marker, 'mouseover', function(event) {
            marker.setOptions({
              zIndex: 10,
            })
          })
          google.maps.event.addListener(marker, 'click', function(event) {
            marker.setOptions({
              zIndex: 10,
            })
          })
          google.maps.event.addListener(marker, 'mouseout', function(event) {
            marker.setOptions({
              zIndex: 1,
            })
          })
        })

        /* Bubble events */
        if (!self.is_single) {
          $(window).on('bubble_opened', function(e, bubble) {
            self.locator.markers.map(function(marker, i) {
              if (marker.originalIcon != undefined) {
                marker.setIcon(marker.originalIcon)
                marker.setOptions({
                  zIndex: 1,
                })
              }
              $('.locator-map > .locator-bubble').remove()
            })
            if (bubble.marker != undefined && bubble.marker.icon != undefined) {
              bubble.marker.originalIcon = bubble.marker.icon
              if ($.mlmi.mobile.isMobile) {
                bubble.marker.mobileBubble = $(bubble.content)
                $('.locator-map').append(bubble.marker.mobileBubble)
                bubble.marker.setOptions({
                  zIndex: 10,
                })
              } else {
                bubble.marker.setIcon({
                  url: '/img/markers/marker-alt.svg',
                  size: new google.maps.Size(26, 66),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(26 / 2, 44 * .667),
                  scaledSize: new google.maps.Size(26, 44),
                  zIndex: 10,
                })
              }
            }
          })
          $(window).on('bubble_closed', function(e, bubble) {
            self.locator.markers.map(function(marker, i) {
              if (marker.originalIcon != undefined) {
                marker.setIcon(marker.originalIcon)
                marker.setOptions({
                  zIndex: 1,
                })
              }
            })
            $('.locator-map > .locator-bubble').remove()
          })
        }
      }
    }
  },
}
